module.exports = __webpack_public_path__ + "bg_texture-1.png";